import DEFAULT_NODE from '../plugins/DEFAULT_NODE';
import createSimpleHtmlBlockPlugin from './createSimpleHtmlBlockPlugin';
function createHeadingsPlugin(def) {
    return createSimpleHtmlBlockPlugin({
        type: def.type,
        hotKey: 'mod+' + def.level,
        replaceOnRemove: DEFAULT_NODE,
        icon: def.icon,
        tagName: 'h' + def.level,
    });
}
export default createHeadingsPlugin;
//# sourceMappingURL=createHeadingsPlugin.js.map